import { AxiosPromise } from "axios";
import { CONSTANT_CONFIG } from "../../constants";
import { HttpService } from "../../services/http.services";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.ACCOMMODATION_SERVER_PREFIX}/bill-generation`;
const endpoints = {
    list: () => `${RESOURCE_ENDPOINT}`,
    getById: (id: any) => `${RESOURCE_ENDPOINT}/${id}`,
    getBillGenerationListByApplicationId: (applicationId: any) =>
        `${RESOURCE_ENDPOINT}/bill-list-by-application-id/${applicationId}`,
    getApplicationsByForBill: (id: any) =>
        `${RESOURCE_ENDPOINT}/getApplicationsByForBill/${id}`,
    getApplication: (id: any) => `${RESOURCE_ENDPOINT}/get-application/${id}`,
    getByWhere: () => `${RESOURCE_ENDPOINT}/getByWhere`,
    create: () => `${RESOURCE_ENDPOINT}`,
    update: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    updatePartial: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    delete: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    bulk: () => `${RESOURCE_ENDPOINT}/bulk`,
    dropdown: () => `${RESOURCE_ENDPOINT}/dropdown`,
    getPaymentRefundDiscountData: (applicationId: Number) =>
        `${RESOURCE_ENDPOINT}/get-payment-refund-discount-data/${applicationId}`,
};

export default class BillGenerationApi {
    public list = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.list();
        return HttpService.get(url, params, headers);
    };

    public getById = (id: any): AxiosPromise<any> => {
        const url = endpoints.getById(id);
        return HttpService.get(url);
    };

    public getBillGenerationListByApplicationId = (
        applicationId: any
    ): AxiosPromise<any> => {
        const url =
            endpoints.getBillGenerationListByApplicationId(applicationId);
        return HttpService.get(url);
    };

    public getApplicationsByForBill = (id: any): AxiosPromise<any> => {
        const url = endpoints.getApplicationsByForBill(id);
        return HttpService.get(url);
    };

    public getApplication = (id: any): AxiosPromise<any> => {
        const url = endpoints.getApplication(id);
        return HttpService.get(url);
    };

    public getByWhere = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getByWhere();
        return HttpService.get(url, params, headers);
    };

    public create = (
        payload = {},
        params = {},
        headers = {}
    ): AxiosPromise<any> => {
        const url = endpoints.create();
        return HttpService.post(url, payload, params, headers);
    };

    public update = (
        id: any,
        payload = {},
        params = {},
        headers = {}
    ): AxiosPromise<any> => {
        const url = endpoints.update(id);
        return HttpService.put(url, payload, params, headers);
    };

    public updatePartial = (
        id: any,
        payload = {},
        params = {},
        headers = {}
    ): AxiosPromise<any> => {
        const url = endpoints.updatePartial(id);
        return HttpService.patch(url, payload, params, headers);
    };

    public delete = (id: any, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.delete(id);
        return HttpService.delete(url, params, headers);
    };

    public bulk = (
        payload = {},
        params = {},
        headers = {}
    ): AxiosPromise<any> => {
        const url = endpoints.bulk();
        return HttpService.post(url, payload, params, headers);
    };

    public dropdown = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.dropdown();
        return HttpService.get(url, params, headers);
    };

    public getPaymentRefundDiscountData = (
        applicationId: any
    ): AxiosPromise<any> => {
        const url = endpoints.getPaymentRefundDiscountData(applicationId);
        return HttpService.get(url);
    };
}
